import { Col, Row, Container, Card } from "react-bootstrap"
import "./Contact.css"

export const Contact = ({ contentData }) => {
    return (
        <div className="contact-container bg-light py-5" id="contact">
            <Container>
                <Row className="contact-content">
                    <Col className="d-flex flex-column justify-content-center align-items-center">
                        <h1 className="esd-font s-header mb-5">Contact</h1>
                        <h2>I would <span><i className="bi bi-heart-fill text-warning"></i></span> to hear from you</h2>
                        <p>Get in touch</p>
                        <div className="d-flex flex-column flex-lg-row">
                            {
                                contentData.contact.map((contact, index) => (

                                    <Card className="contact-card m-1 p-2 text-center" key={index}>
                                        <i className={contact.className}></i>
                                        <Card.Text>{contact.contactDetail}</Card.Text>
                                    </Card>

                                ))
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}